import { render, staticRenderFns } from "./MButtonSelectTooltip.vue?vue&type=template&id=5a7fb754"
import script from "./MButtonSelectTooltip.vue?vue&type=script&lang=ts"
export * from "./MButtonSelectTooltip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports